import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
  CSpinner,
  CInvalidFeedback,
  CSelect,
  CInputGroup,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory, useParams } from "react-router-dom";

// import usersData from "../users/UsersData";
const AddUserForTransfer = () => {
  useEffect(() => {
    getDistrictList(true);
    getCircleListDrop(true);
    getcompanycategory();
  }, []);
  const { lotId } = useParams("lotId");
  let decrypted = window.atob(lotId);

  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [emailId, setEmailId] = useState();
  const [mobile, setMobile] = useState();
  const [username, setUserName] = useState();
  const [houseNo, setHouseNo] = useState();
  const [streetName, setStreetName] = useState();
  const [area, setArea] = useState();
  const [city, setCity] = useState();
  const [disctrict, setDistrict] = useState();
  const [state, setState] = useState();
  const [pincode, setPincode] = useState();
  const [contact1, setContact1] = useState();
  const [contact2, setContact2] = useState();
  const [contact3, setContact3] = useState();
  const [contact4, setContact4] = useState();
  const [contact5, setContact5] = useState();
  const [fax, setFax] = useState();
  const [alternateEmail, setAlternateEmail] = useState();
  const [companyname, setcompanyname] = useState();
  const [companypan, setcompanypan] = useState();
  const [companytype, setcompanytype] = useState();
  const [companyregistdistrict, setcompanyregistdistrict] = useState();
  const [companygst, setcompanygst] = useState();
  const [companydirect1, setcompanydirect1] = useState();
  const [companydirect2, setcompanydirect2] = useState();
  const [companydirect3, setcompanydirect3] = useState();
  const [companydirect4, setcompanydirect4] = useState();
  const [companydirect5, setcompanydirect5] = useState();
  const [companydirect6, setcompanydirect6] = useState();
  const [companydirect7, setcompanydirect7] = useState();
  const [companydirect8, setcompanydirect8] = useState();
  const [companydirect9, setcompanydirect9] = useState();
  // eslint-disable-next-line no-unused-vars
  const [emdamt, setemdamt] = useState();
  const [bankaccountnumber, setbankaccountnumber] = useState();
  const [bankaccounttype, setbankaccounttype] = useState();
  const [bankbranch, setbankbranch] = useState();
  const [ifsccode, setifsccode] = useState();
  // eslint-disable-next-line no-unused-vars
  const [subRoleId, setSubRoleId] = useState();
  const [circleId, setCircleId] = useState(0);
  const [districtId, setDistrictId] = useState(0);
  const [items, setItems] = useState([]);
  const [companycategory, setcompanycategory] = useState([]);
  const [selectedcompanycategoryid, setselectedcompanycategoryid] = useState(
    []
  );
  // eslint-disable-next-line no-unused-vars
  const [companys, setcompanys] = useState([]);
  const [itemsCricle, setitemsCricle] = useState([]);

  const [fileEventPanCard, setfileEventPanCard] = useState(false);
  const [selectedPanCardFile, setselectedPanCardFile] = useState();

  const [fileEventAadharCard, setfileEventAadharCard] = useState(false);
  const [selectedAadharCardFile, setselectedAadharCardFile] = useState();

  const [fileEventITR1, setfileEventITR1] = useState(false);
  const [selectedITR1File, setselectedITR1File] = useState();

  const [fileEventITR2, setfileEventITR2] = useState(false);
  const [selectedITR2File, setselectedITR2File] = useState();

  const [fileEventITR3, setfileEventITR3] = useState(false);
  const [selectedITR3File, setselectedITR3File] = useState();

  const [fileEventGST, setfileEventGST] = useState(false);
  const [selectedGSTFile, setselectedGSTFile] = useState();

  const [fileEventDFORegCer, setfileEventDFORegCer] = useState(false);
  const [selectedDFORegCerFile, setselectedDFORegCerFile] = useState();

  const [
    fileEventScanCopyOfPartnershipFirm,
    setfileEventScanCopyOfPartnershipFirm,
  ] = useState(false);
  const [
    selectedScanCopyOfPartnershipFirmFile,
    setselectedScanCopyOfPartnershipFirmFile,
  ] = useState();

  const [fileEventMOA, setfileEventMOA] = useState(false);
  const [selectedMOAFile, setselectedMOAFile] = useState();

  const [fileEventHUF, setfileEventHUF] = useState(false);
  const [selectedHUFFile, setselectedHUFFile] = useState();

  const [fileEventOtherDocument, setfileEventOtherDocument] = useState(false);
  const [selectedOtherDocumentFile, setselectedOtherDocumentFile] = useState();

  const SaveUserDoc = async (userid) => {
    debugger;
    let ePanCard = fileEventPanCard;
    let eAadharCard = fileEventAadharCard;
    let eITR1 = fileEventITR1;
    let eITR2 = fileEventITR2;
    let eITR3 = fileEventITR3;
    let eGST = fileEventGST;
    let eDFORegCer = fileEventDFORegCer;
    let eScanCopyOfPartnershipFirm = fileEventScanCopyOfPartnershipFirm;
    let eMOA = fileEventMOA;
    let eHUF = fileEventHUF;
    let eOtherDocument = fileEventOtherDocument;

    if (ePanCard === false) {
    }
    if (eAadharCard === false) {
    }
    if (eITR1 === false) {
    }
    if (eITR2 === false) {
    }
    if (eITR3 === false) {
    }
    if (eGST === false) {
    }
    if (eDFORegCer === false) {
    }

    setselectedPanCardFile(ePanCard.target.files[0]);
    setselectedAadharCardFile(eAadharCard.target.files[0]);
    setselectedITR1File(eITR1.target.files[0]);
    setselectedITR2File(eITR2.target.files[0]);
    setselectedITR3File(eITR3.target.files[0]);
    setselectedGSTFile(eGST.target.files[0]);
    setselectedDFORegCerFile(eDFORegCer.target.files[0]);

    if (eScanCopyOfPartnershipFirm !== false) {
      setselectedScanCopyOfPartnershipFirmFile(
        eScanCopyOfPartnershipFirm.target.files[0]
      );
    }

    if (eMOA !== false) {
      setselectedMOAFile(eMOA.target.files[0]);
    }

    if (eHUF !== false) {
      setselectedHUFFile(eHUF.target.files[0]);
    }

    if (eOtherDocument !== false) {
      setselectedOtherDocumentFile(eOtherDocument.target.files[0]);
    }

    const filesePanCard = ePanCard.target.files;
    const fileseAadharCard = eAadharCard.target.files;
    const fileseITR1 = eITR1.target.files;
    const fileseITR2 = eITR2.target.files;
    const fileseITR3 = eITR3.target.files;
    const fileseeGST = eGST.target.files;
    const fileseDFORegCer = eDFORegCer.target.files;

    // const fileseScanCopyOfPartnershipFirm = null;
    // if (eScanCopyOfPartnershipFirm !== false) {
    //    fileseScanCopyOfPartnershipFirm = eScanCopyOfPartnershipFirm.target.files;
    // }

    // const fileseMOA = null;
    // if (eMOA !== false) {
    //    fileseMOA = eMOA.target.files;
    // }

    // const fileseHUF = null;
    // if (eHUF !== false) {
    //   fileseHUF = eHUF.target.files;
    // }

    // const fileseOtherDocument = null;
    // if (eOtherDocument !== false) {
    //  fileseOtherDocument = eOtherDocument.target.files;
    // }

    // const fileseScanCopyOfPartnershipFirm = null;
    // if (eScanCopyOfPartnershipFirm !== false) {
    //    fileseScanCopyOfPartnershipFirm = eScanCopyOfPartnershipFirm.target.files;
    // }

    // const fileseMOA = null;
    // if (eMOA !== false) {
    //    fileseMOA = eMOA.target.files;
    // }

    // const fileseHUF = null;
    // if (eHUF !== false) {
    //   fileseHUF = eHUF.target.files;
    // }

    // const fileseOtherDocument = null;
    // if (eOtherDocument !== false) {
    //  fileseOtherDocument = eOtherDocument.target.files;
    // }

    const formData = new FormData();
    const header = new Headers();
    header.append("Accept", "application/json");

    formData.append("filesePanCard", filesePanCard[0]);
    formData.append("fileseAadharCard", fileseAadharCard[0]);
    formData.append("fileseITR1", fileseITR1[0]);
    formData.append("fileseeITR2", fileseITR2[0]);
    formData.append("fileseITR3", fileseITR3[0]);
    formData.append("fileseeGST", fileseeGST[0]);
    formData.append("fileseDFORegCer", fileseDFORegCer[0]);

    if (eScanCopyOfPartnershipFirm !== false) {
      formData.append(
        "fileseScanCopyOfPartnershipFirm",
        eScanCopyOfPartnershipFirm.target.files[0]
      );
    } else {
      formData.append("fileseScanCopyOfPartnershipFirm", null);
    }

    if (eMOA !== false) {
      formData.append("fileseMOA", eMOA.target.files[0]);
    } else {
      formData.append("fileseMOA", null);
    }

    if (eHUF !== false) {
      formData.append("fileseHUF", eHUF.target.files[0]);
    } else {
      formData.append("fileseHUF", null);
    }

    if (eOtherDocument !== false) {
      formData.append("fileseOtherDocument", eOtherDocument.target.files[0]);
    } else {
      formData.append("fileseOtherDocument", null);
    }

   const response =  await apiCall(`User/userdoc/${userid}`, "POST", header, formData);
    if (response.status === 200) { 

       alert("User Added with Documents Successfully");
    } else {
     
      alert("User document upload fails.");
    }





  };

  const postUserData = async () => {
    if (emailId === undefined || emailId === "") {
      alert("Please enter EmailId");
      return;
    }

    if (mobile === undefined || mobile === "") {
      alert("Please enter Mobile");
      return;
    }

    if (username === undefined || username === "") {
      alert("Please enter User Name");
      return;
    }

    if (companyname === undefined || companyname === "") {
      alert("Please enter Company Name");
      return;
    }

    if (companypan === undefined || companypan === "") {
      alert("Please enter Company PAN");
      return;
    }

    if (companytype === undefined || companytype === "") {
      alert("Please enter Company Type");
      return;
    }

    if (
      selectedcompanycategoryid === undefined ||
      selectedcompanycategoryid === 0
    ) {
      alert("Please select Selecte Companycategoryid");
      return;
    }

    if (companyregistdistrict === undefined || companyregistdistrict === "") {
      alert("Please enter Company Regist District");
      return;
    }

    if (companygst === undefined || companygst === "") {
      alert("Please enter Company GST");
      return;
    }

    if (companydirect1 === undefined || companydirect1 === "") {
      alert("Please enter Company Direct-1");
      return;
    }

    if (bankaccountnumber === undefined || bankaccountnumber === "") {
      alert("Please enter Bank Account Number");
      return;
    }

    if (bankaccounttype === undefined || bankaccounttype === "") {
      alert("Please enter Bank Account Type");
      return;
    }

    if (bankbranch === undefined || bankbranch === "") {
      alert("Please enter Bank Branch");
      return;
    }

    if (ifsccode === undefined || ifsccode === "") {
      alert("Please enter IFSC Code");
      return;
    }

    let ePanCard = fileEventPanCard;
    let eAadharCard = fileEventAadharCard;
    let eITR1 = fileEventITR1;
    let eITR2 = fileEventITR2;
    let eITR3 = fileEventITR3;
    let eGST = fileEventGST;
    let eDFORegCer = fileEventDFORegCer;

    if (ePanCard === false) {
      alert("Please upload pan card");
      return;
    }

    if (eAadharCard === false) {
      alert("Please upload Aadhar card");
      return;
    }
    if (eITR1 === false) {
      alert("Please upload ITR1");
      return;
    }
    if (eITR2 === false) {
      alert("Please upload ITR2");
      return;
    }
    if (eITR3 === false) {
      alert("Please upload ITR3");
      return;
    }
    if (eGST === false) {
      alert("Please upload GST");
      return;
    }
    if (eDFORegCer === false) {
      alert("Please upload DFO Registration Certificate");
      return;
    }

    //e.preventDefault();
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "User/AddUserFromTransfer",
      "POST",
      header,
      JSON.stringify({
        emailId: emailId,
        mobile: mobile,
        username: username,
        houseNo: houseNo,
        streetName: streetName,
        area: area,
        city: city,
        disctrict: disctrict,
        state: state,
        pincode: pincode,
        contact1: contact1,
        contact2: contact2,
        contact3: contact3,
        contact4: contact4,
        contact5: contact5,
        fax: fax,
        alternateEmail: alternateEmail,
        roleId: 2,
        subRoleId: null,
        circleId: Number(circleId),
        // districtId: Number(selecteddistrictid),
        companyname: companyname,
        companypan: companypan,
        companytype: companytype,
        selectedcompanycategoryid: selectedcompanycategoryid,
        companyregistdistrict: companyregistdistrict,
        companygst: companygst,
        companydirect1: companydirect1,
        companydirect2: companydirect2,
        companydirect3: companydirect3,
        companydirect4: companydirect4,
        companydirect5: companydirect5,
        companydirect6: companydirect6,
        companydirect7: companydirect7,
        companydirect8: companydirect8,
        companydirect9: companydirect9,
        EMDAmt: Number(0),
        AccountNumber: bankaccountnumber,
        BankAccountType: bankaccounttype,
        BankBranch: bankbranch,
        IFSCCode: ifsccode,
      })
    );

    const jsonobj = await response.json();
debugger;
    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      debugger;
     
      SaveUserDoc(jsonobj);
      
    //  history.push(`/transferlot/${window.btoa(decrypted)}`);





      // const headerfortransfer = new Headers();
      // headerfortransfer.append("Content-Type", "application/json");
      // const responseData = await apiCall(
      //   "LotTransfer/add",
      //   "POST",
      //   headerfortransfer,
      //   JSON.stringify({
      //     lotId: Number(decrypted),
      //     transferFromUserId: Number(authenticated.district),
      //     transferToUserId: Number(jsonobj)
      //   })
      // );

      // const jsonobjData = await responseData.json();

      // if (responseData.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      //   history.push("/lotlist");
      // }
    } else {
      //alert("EmailAddress or mobile no already exists.");
      alert("EmailAddress already exists.");
    }
    setloading(false);
  };

  const getcompanycategory = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Company_Category`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setcompanycategory(distJsonobj);
    }
    setloading(false);
  };

  const getDistrictList = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`District_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };

  // const getCompanyList = async () => {
  //   setloading(true);
  //   const header = new Headers();
  //   const distResponse = await apiCall(`Company`, "GET", header, null);
  //   const distJsonobj = await distResponse.json();
  //   if (distResponse.status === 200) {
  //     setcompanys(distJsonobj);
  //   }
  //   setloading(false);
  // };

  const getCircleListDrop = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Circle_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setitemsCricle(distJsonobj);
    }
    setloading(false);
  };
  let cfoDrop = (
    <CCol xl={4}>
      <CLabel>Select Circle : </CLabel>
      <CSelect
        required
        // value={circleId}
        aria-label="Default select example"
        onChange={(e) => setCircleId(e.target.value)}
        invalid={circleId === "" ? true : false}
        id="validationCustom19"
      >
        <option value="">Select Circle</option>
        {itemsCricle.map((item, key) => (
          <option key={key} value={item.circleId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom19">
        Please enter circleId
      </CInvalidFeedback>
    </CCol>
  );

  let dfoDrop = (
    <CCol xl={4}>
      <CLabel>Select District Union : </CLabel>
      <CSelect
        required
        // value={districtId}
        aria-label="Default select example"
        onChange={(e) => {
          setDistrictId(e.target.value);
        }}
        invalid={districtId === "" ? true : false}
        id="validationCustom20"
      >
        <option value="">Select District Union</option>
        {items.map((item, key) => (
          <option key={key} value={item.districtId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom20">
        Please enter districtId
      </CInvalidFeedback>
    </CCol>
  );
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Add User</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CForm onSubmit={postUserData} className="was-validation">
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel htmlFor="validationCustom01">
              {" "}
              Email Address <span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              required
              type="email"
              value={emailId}
              onChange={(e) => {
                setEmailId(e.target.value);
              }}
              id="validationCustom01"
              invalid={emailId === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom01">
              Please enter Email ID
            </CInvalidFeedback>
          </CCol>
          <CCol xl={4}>
            <CLabel htmlFor="validationCustom02">
              {" "}
              Mobile No.<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              required
              type="number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              id="validationCustom02"
              invalid={mobile === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom02">
              Please enter Mobile
            </CInvalidFeedback>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Father Name<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              required
              type="text"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              id="validationCustom03"
              invalid={username === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom03">
              Please enter Username
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> House No. : </CLabel>
            <CInput
              type="text"
              value={houseNo}
              onChange={(e) => setHouseNo(e.target.value)}
              id="validationCustom04"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Street Name : </CLabel>
            <CInput
              type="text"
              value={streetName}
              onChange={(e) => setStreetName(e.target.value)}
              id="validationCustom05"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Area : </CLabel>
            <CInput
              type="text"
              value={area}
              onChange={(e) => setArea(e.target.value)}
              id="validationCustom06"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> City : </CLabel>
            <CInput
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              id="validationCustom07"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Disctrict : </CLabel>
            <CInput
              type="text"
              value={disctrict}
              onChange={(e) => setDistrict(e.target.value)}
              id="validationCustom08"
            />
          </CCol>

          <CCol xl={4}>
            <CLabel> State : </CLabel>
            <CInput
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              id="validationCustom09"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> Pincode : </CLabel>
            <CInput
              type="text"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              id="validationCustom10"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Contact 1 : </CLabel>
            <CInput
              type="text"
              value={contact1}
              onChange={(e) => setContact1(e.target.value)}
              id="validationCustom11"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Contact 2 : </CLabel>
            <CInput
              type="text"
              value={contact2}
              onChange={(e) => setContact2(e.target.value)}
              id="validationCustom12"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> Contact 3 : </CLabel>
            <CInput
              type="text"
              value={contact3}
              onChange={(e) => setContact3(e.target.value)}
              id="validationCustom13"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Contact 4 : </CLabel>
            <CInput
              type="text"
              value={contact4}
              onChange={(e) => setContact4(e.target.value)}
              id="validationCustom14"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Contact 5 : </CLabel>
            <CInput
              type="text"
              value={contact5}
              onChange={(e) => setContact5(e.target.value)}
              id="validationCustom15"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> Fax : </CLabel>
            <CInput
              type="text"
              value={fax}
              onChange={(e) => setFax(e.target.value)}
              id="validationCustom16"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Alternate Email : </CLabel>
            <CInput
              type="text"
              value={alternateEmail}
              onChange={(e) => setAlternateEmail(e.target.value)}
              id="validationCustom17"
            />
          </CCol>
          <CCol xl={4}></CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={12}>
            <h4>Company Details</h4>
            <hr></hr>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company Name<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companyname}
              onChange={(e) => setcompanyname(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company PAN<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companypan}
              onChange={(e) => setcompanypan(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company Type<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companytype}
              onChange={(e) => setcompanytype(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company Category<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CSelect
              aria-label="Default select company"
              onChange={(e) => {
                setselectedcompanycategoryid(e.target.value);
              }}
            >
              <option value="">Select Company</option>
              {companycategory.map((item, key) => (
                <option key={key} value={item.company_Category_Id}>
                  {item.categoryName}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company Registred District<span style={{ color: "red" }}>
                *
              </span>{" "}
              :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companyregistdistrict}
              onChange={(e) => setcompanyregistdistrict(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Company GST<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companygst}
              onChange={(e) => setcompanygst(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={12}>
            <h4>Company Director</h4>
            <hr></hr>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Director Name - 1<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={companydirect1}
              onChange={(e) => setcompanydirect1(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 2 : </CLabel>
            <CInput
              type="text"
              value={companydirect2}
              onChange={(e) => setcompanydirect2(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 3 : </CLabel>
            <CInput
              type="text"
              value={companydirect3}
              onChange={(e) => setcompanydirect3(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> Director Name - 4 : </CLabel>
            <CInput
              type="text"
              value={companydirect4}
              onChange={(e) => setcompanydirect4(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 5 : </CLabel>
            <CInput
              type="text"
              value={companydirect5}
              onChange={(e) => setcompanydirect5(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 6 : </CLabel>
            <CInput
              type="text"
              value={companydirect6}
              onChange={(e) => setcompanydirect6(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel> Director Name - 7 : </CLabel>
            <CInput
              type="text"
              value={companydirect7}
              onChange={(e) => setcompanydirect7(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 8 : </CLabel>
            <CInput
              type="text"
              value={companydirect8}
              onChange={(e) => setcompanydirect8(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel> Director Name - 9 : </CLabel>
            <CInput
              type="text"
              value={companydirect9}
              onChange={(e) => setcompanydirect9(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={12}>
            <h4>Bank Details</h4>
            <hr></hr>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4} hidden="true">
            <CLabel hidden="true">
              {" "}
              EMD Amt<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value="0"
              hidden="true"
              onChange={(e) => setemdamt(0)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Account Number<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={bankaccountnumber}
              onChange={(e) => setbankaccountnumber(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Bank Account Type<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={bankaccounttype}
              onChange={(e) => setbankaccounttype(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Bank Branch<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={bankbranch}
              onChange={(e) => setbankbranch(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              IFSC Code<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInput
              type="text"
              value={ifsccode}
              onChange={(e) => setifsccode(e.target.value)}
              id="validationCustom21"
            />
          </CCol>
          <CCol xl={4}></CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={12}>
            <h4>User Document</h4>
            <hr></hr>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Pan Card<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventPanCard(e);
                    setselectedPanCardFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedPanCardFile ? (
                    selectedPanCardFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Aadhar Card<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventAadharCard(e);
                    setselectedAadharCardFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedAadharCardFile ? (
                    selectedAadharCardFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}></CCol>
        </CRow>

        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              ITR Year-1<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventITR1(e);
                    setselectedITR1File(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedITR1File ? selectedITR1File.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              ITR Year-2<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventITR2(e);
                    setselectedITR2File(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedITR2File ? selectedITR2File.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              ITR Year-3<span style={{ color: "red" }}>*</span> :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventITR3(e);
                    setselectedITR3File(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedITR3File ? selectedITR3File.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              GSTIN Certificate<span style={{ color: "red" }}>*</span>:{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventGST(e);
                    setselectedGSTFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedGSTFile ? selectedGSTFile.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              DFO Registration Certificate
              <span style={{ color: "red" }}>*</span>:{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventDFORegCer(e);
                    setselectedDFORegCerFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedDFORegCerFile ? (
                    selectedDFORegCerFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel> Scanned copy of Partnership Firm: </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventScanCopyOfPartnershipFirm(e);
                    setselectedScanCopyOfPartnershipFirmFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedScanCopyOfPartnershipFirmFile ? (
                    selectedScanCopyOfPartnershipFirmFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          <CCol xl={4}>
            <CLabel>
              {" "}
              Scanned copy of Certificate of Company Incorporation of Latest
              Directors of company, AOA and MOA :{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventMOA(e);
                    setselectedMOAFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedMOAFile ? selectedMOAFile.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel>
              {" "}
              Scanned copy of list of family members in case of H.U.F.:{" "}
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventHUF(e);
                    setselectedHUFFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedHUFFile ? selectedHUFFile.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
          <CCol xl={4}>
            <CLabel> Any other related document: </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  name="file"
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                  onChange={(e) => {
                    setfileEventOtherDocument(e);
                    setselectedOtherDocumentFile(e.target.files[0]);
                  }}
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedOtherDocumentFile ? (
                    selectedOtherDocumentFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-5">
          {subRoleId === 2 ? (
            <>{cfoDrop}</>
          ) : subRoleId === 3 ? (
            <>{dfoDrop}</>
          ) : (
            ""
          )}
        </CRow>

        <CRow className="mb-3 ml-3">
          <CRow className="mb-3 ml-5 mt-3">
            {loading ? (
              <CSpinner
                className="spinner-grow"
                color="success"
                variant="grow"
              />
            ) : (
              <>
                <CButton color="success" onClick={() => postUserData()}>
                  Add User
                </CButton>
                <CButton
                  color="danger"
                  className="ml-2"
                  onClick={() => history.goBack()}
                >
                  Go Back
                </CButton>
              </>
            )}
          </CRow>
        </CRow>
      </CForm>
    </>
  );
};
export default AddUserForTransfer;
